import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { create } from "../../services/services";

const Proprietaire = (props) => {
  // console.log({props})
  const navigate = useNavigate();
  const [email, setEmail] = useState(null);
  const informMe = () => {
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!email) {
      toast.error('Veuillez entrer une adresse email', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
      });
      return;
    }
  
    if (!emailRegex.test(email)) {
      toast.error('Veuillez entrer une adresse email valide', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: true,
      });
      return;
    }
  
    // Here you would typically make an API call to save the email
    create({email},`google-etablissements/${props?.placeId}/notify`)
    .then((res)=>{
 
  toast.success(`Nous vous informerons lorsque ${props?.proprietaire} sera disponible sur Twyny!`, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    draggable: true,
  });
    })
    .catch((err)=>{
      // console.log(err)
    })
  
  
    // Clear the email field after submission
    setEmail('');
  };
  return (
    <div className="twyny-border-bottom">
      <div className="card-grey ">
        <h3 className="grey500 mb-0">
          Vous êtes propriétaire de cet établissement ?
        </h3>
        <p className="body grey66 mt-16 mb-0">
        Découvrez la prise de rendez-vous en ligne en quelques clics ! 
        Libérez-vous du temps et gardez le contrôle de votre activité ! 
        Twyny est la plateforme de réservation en libre-service qui vous 
        simplifie la vie. Vos clients paient à l’avance en ligne,
         et vous êtes rémunéré dès la prestation effectuée.
        </p>
        <button
          className="twyny-cta-primary mt-24"
          onClick={() => navigate("/registerPrestataire",{state:{placeId:props?.placeId}})}
        >
          Activer ma page établissement
        </button>
      </div>
      <div className="mt-32">
        <h4 className="grey500 mb-0">
          Restez informés de l’arrivée de {props?.proprietaire} sur Twyny
        </h4>
        <p className="body grey66 mt-8 mb-0">
          Nous vous enverrons un email lorsque la réservation en ligne chez{" "}
          {props?.proprietaire} sera disponible.
        </p>
        <div className="mt-16">
        <label className="grey66 legend">Adresse e-mail   </label>
          <div className="input-wrapper d-flex mt-4">
            <input
              type="email" // Keep SIRET as text
              placeholder="john@email.com"
              value={email}
              className="w-50 h-auto"
              onChange={(e) => setEmail(e.target.value)}
            />
         
            <button className="twyny-cta-secondary ml-8" onClick={informMe}>Rester informé</button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Proprietaire;
